import styled from 'styled-components';

export const ScMainPreviewWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;
